export default "__VITE_ASSET__BaOt2TCX__"